import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { MaterialModal } from 'components/layout'
import { NotificationItem, Title } from 'components/misc'
import { NotificationLoader } from 'components/loaders'
import { COLORS } from 'constants/layout/section-colors'

export default class NotificationCentreModal extends Component {
  static propTypes = {
    notificationsData: PropTypes.object,
    loading: PropTypes.bool,
    modalId: PropTypes.string,
    onMarkAsRead: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.notificationsData !== get(nextProps, 'notificationsData')) {
      const data = get(nextProps, 'notificationsData')

      const newNotifications = get(data, 'newNotifications')

      const notificationsToProcess = newNotifications && newNotifications.map(i => i.id)

      this.props.onMarkAsRead(notificationsToProcess)
    }
  }

  render() {
    const { notificationsData, modalId, loading } = this.props

    const newNotifications = get(notificationsData, 'newNotifications')
    const olderNotifications = get(notificationsData, 'olderNotifications')

    const hasNew = Boolean(
      newNotifications && Array.isArray(newNotifications) && newNotifications[0]
    )
    const hasOlder = Boolean(
      olderNotifications &&
        Array.isArray(olderNotifications) &&
        olderNotifications[0]
    )

    return (
      <MaterialModal.Body
        id={modalId}
        title="Notifications"
        titleKey="moduleTitle.notifications"
      >
        <MaterialModal.Content noFooter>
          {loading && <NotificationLoader />}

          {!loading &&
            hasNew && (
              <div>
                <Title
                  h3
                  colorClass={COLORS.blue.value}
                  style={{ fontSize: '1.4rem', marginLeft: '14px' }}
                  intlKey="moduleTitle.new_notifications"
                >
                  New Notifications
                </Title>
                {newNotifications.map(item => (
                  <NotificationItem data={item} key={item.id} />
                ))}
              </div>
            )}

          {!loading &&
            hasOlder && (
              <div>
                <Title
                  h3
                  colorClass={COLORS.blue.value}
                  style={{ fontSize: '1.4rem', marginLeft: '14px' }}
                  intlKey="moduleTitle.older_notifications"
                >
                  Older Notifications
                </Title>
                {olderNotifications.map(item => (
                  <NotificationItem data={item} key={item.id} />
                ))}
              </div>
            )}

          {!loading &&
            !hasNew &&
            !hasOlder && (
              <Title h3 style={{ fontSize: '1.4rem', marginLeft: '14px' }} intlKey="moduleTitle.no_notifications">
                No Notifications
              </Title>
            )}
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
